import { UserManager, User } from 'oidc-client';
import * as angular from "angular";

import dashboardModule from "./dashboard/dashboard.module";
import { configRoute } from "./app.config";

import coreModule from "./core/core.module";
import commonModule from "./common/app.common";

import manageServicesModule from "./manage/manage.module";
import logsModule from "./logs/logs.module";
import bengLogsModule from "./beng-logs/beng-logs.module";
import usersModule from "./users/users.module";
import schedulerModule from "./scheduler/scheduler.module";
import backupAndRestoreModule from "./backup-and-restore/backup-and-restore.module";

import { configTheme, configIcons } from "./app-theme.config";

import requireResetPasswordModule from "./require-reset-password/require-reset-password.module";
import registerModule from "./register/register.module";
import changePasswordModule from "./change-password/change-password.module";
import completeProfileModule from "./complete-profile/complete-profile.module";
import resetPasswordModule from "./reset-password/reset-password.module";
import { ILocationProvider } from "angular";
import emailConfirmedModule from "./email-confirmed/email-confirmed.module";

const configLocationProvider = ($locationProvider: ILocationProvider) => {
    $locationProvider.hashPrefix("");
};
configLocationProvider.$inject = ["$locationProvider"];

export const buildAnonymousAppModule = (adminUserManager: UserManager) => {
    coreModule.constant('USERNAME_CLAIM_TYPE', 'preferred_username');

    return angular
        .module("board.web.admin.anonymous", [
            coreModule.name,
            commonModule,
            requireResetPasswordModule,
            registerModule,
            changePasswordModule,
            completeProfileModule,
            resetPasswordModule,
            emailConfirmedModule
        ])
        .constant("BoardWebAdminUserManager", adminUserManager)
        .config(configLocationProvider)
        .config(configTheme)
        .config(configIcons)
        .name;
};


// WEBPACK FOOTER //
// ./app/anonymous-app.module.ts